import React from 'react'
import PropTypes from 'prop-types'
import { Tag, Space } from 'antd'
import { SwapOutlined } from '@ant-design/icons'
import { FormatedTimestamp } from './FormatedTimestamp'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../config'

/**
 * Displays a range between two dates or timestamps.
 *
 * @param {Object} props
 * @param {Array} props.dates - Array of start and end dates in a specified format.
 * @param {Array} props.timestamps - Array of start and end timestamps.
 * @param {string} props.dateFormat - Format to parse the dates if not the default (YYYY-MM-DD).
 */
const BetweenDates = ({
	dates = [],
	timestamps = [],
	dateFormat = DATE_FORMAT,
	formatedAs = DATE_FORMAT
}) => {
	// Determine if we should use timestamps or convert dates to timestamps using the specified format
	const [start, end] =
		timestamps.length === 2
			? timestamps
			: dates.length === 2
			? dates.map((date) => dayjs(date, dateFormat).unix())
			: [null, null] // Convert dates to timestamps with the provided format

	return (
		<Tag color="default" className="we-between-dates">
			<Space style={{ width: '100%' }} align="center" size={3}>
				<span>
					<FormatedTimestamp
						timestamp={start}
						formatedAs={formatedAs}
					/>
				</span>
				<div style={{ display: 'flex' }}>
					<SwapOutlined
						style={{ fontSize: '8px', color: '#959595' }}
					/>
				</div>
				<span>
					<FormatedTimestamp
						timestamp={end}
						formatedAs={formatedAs}
					/>
				</span>
			</Space>
		</Tag>
	)
}

BetweenDates.propTypes = {
	dates: PropTypes.arrayOf(PropTypes.string),
	timestamps: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.number, PropTypes.string])
	),
	dateFormat: PropTypes.string,
	formatedAs: PropTypes.string
}

export default BetweenDates
